export const envs = {
  get BASE_URL(): string {
    return window.env?.BASE_URL ?? import.meta.env.VITE_BASE_URL ?? '';
  },
  get DISPLAY_DATA_TEST_ID(): boolean {
    return !!(
      window.env?.DISPLAY_DATA_TEST_ID ??
      import.meta.env.VITE_DISPLAY_DATA_TEST_ID
    );
  },
};
